import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import CustomerCartLogo from 'src/common/components/cart-icon/customer-cart-image';
import ThemeLogo from 'src/common/components/theme-logo/theme-logo';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { StateConfig } from 'src/common/interfaces/dtos/ITouchpointTheme';
import { AppState } from 'src/common/redux/configure-store';
import TrainingModeWatermark from 'src/common/training-mode/training-mode-watermark';
import { ThemeContext } from 'src/emerald-theme-provider';
import { styles } from './customer-display-thank-you-styles';

const CustomerDisplayTenderExchange: React.FC<ReturnType<typeof mapStateToProps>> = ({
  tenderExchangeDetails,
}) => {
  const { emeraldTheme } = useContext(ThemeContext);
  const changeDueStyles = emeraldTheme?.customerDisplay?.changeDue;
  const changeDueProps: StateConfig = {
    backgroundColor: changeDueStyles?.backgroundColor,
    backgroundImageURL: changeDueStyles?.backgroundImageURL,
    bodyTextColor: changeDueStyles?.bodyTextColor,
    headingTextColor: changeDueStyles?.headingTextColor,
  };
  const trainingModeActive = useSelector((state: AppState): boolean => state.posMode.trainingMode);
  const { t } = useTranslation();

  const classes = styles(changeDueProps);
  const defaultTender = 'Tender';
  const trainingModeWatermark = trainingModeActive ? (
    <Grid data-testid='customer-display-training-watermark'>
      <TrainingModeWatermark supplementalStyles={classes.trainingWaterMark} />
    </Grid>
  ) : null;
  return (
    <Grid
      container
      data-testid='customer-display-thank-you-tender-exchange'
      className={clsx(
        'fullWidth',
        'fullHeight',
        trainingModeActive ? classes.trainingModeBackground : classes.themeBackground,
      )}
      justifyContent='center'
      direction='column'
      alignItems='center'
    >
      {trainingModeWatermark}
      <Grid
        container
        direction='column'
        alignItems='center'
        justifyContent='center'
        className={classes.thankYouContainer}
      >
        <Grid item className={classes.line}>
          <CustomerCartLogo styles={classes.customerCartLogo} />
        </Grid>
        <Grid item>
          <Typography
            className={classes.title}
            data-testid='customer-display-thank-you-message-tender-exchange'
          >
            {t('CustomerTenderExchange')}
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            data-testid='customer-display-thank-you-moneyback-tender-exchange'
            variant='h2'
            className={classes.amount}
          >
            {convertCurrency(Math.abs(tenderExchangeDetails?.exchangeAmount ?? 0))}
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            data-testid='customer-display-thank-you-moneyback-tender-exchange'
            variant='subtitle2'
            className={classes.amount}
          >
            {`${tenderExchangeDetails.paymentTender?.description ??
              defaultTender} to ${tenderExchangeDetails.refundTender?.description ??
              defaultTender}`}
          </Typography>
        </Grid>
        <Grid item>
          <div className={`${classes.bar} ${classes.barNotification}`} />
        </Grid>
        <Grid item className={classes.subTitleContainer}>
          <Typography
            data-testid='customer-display-receipt-message-tender-exchange'
            className={classes.subtitle}
          >
            {t('CashPaymentChangeView_CustomerDisplayGoodbye')}
          </Typography>
        </Grid>
      </Grid>
      <Grid item className={classes.line}>
        <ThemeLogo styles={`${classes.logo}`} />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: AppState) => ({
  tenderExchangeDetails: state.tenderExchange.tenderExchangeDetails,
});

export default connect(mapStateToProps)(CustomerDisplayTenderExchange);
